import script from "./GnssIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./GnssIndex.vue?vue&type=script&setup=true&lang=js"

import "./GnssIndex.vue?vue&type=style&index=0&id=1fe22450&lang=css"

const __exports__ = script;

export default __exports__